import { Release, Filter, ICESFilter, ICESReleaseGroup } from '../../models';
import { FormatterHelper } from '../common/formatter.helper';

export class ReleasesHelper {

    releases: Release[];
    formatter: FormatterHelper;

    constructor() {
        this.releases = [];
        this.formatter = new FormatterHelper();
    }

    public createRelease(data: any): Release {
        let release: Release = {
            ICES: data.RelICES ? data.RelICES : '?',
            Year: data.RelTime,
            Count: data.count
        };
        return release;
    }

    public getRelease(icesName: string) {
        return this.releases.find(release => release.ICES === icesName);
    }

    public findReleases(filter: Filter): Release[] {
        return this.releases.filter(release => release.Year != null && (release.Year === filter.Year || filter.Year == 0));
    }
    
    public groupByICES(releases: Release[]): ICESReleaseGroup[] {
        let groups = [];
        let result = releases.reduce((r, a) => this.group(r, a), Object.create(null));
        // Make a list of groups
        if (result) {
            for (let key in result) {
                groups.push(result[key]);
            }
        }
        return groups;
    }

    public getMinReleaseGroup(groups: ICESReleaseGroup[]): ICESReleaseGroup {
        // return groups.reduce((a, b) => this.min(a, b));
        return this.formatter.getMinGroup(groups);
    }

    public getMaxReleaseGroup(groups: ICESReleaseGroup[]): ICESReleaseGroup {
        // return groups.reduce((a, b) => this.max(a, b));
        return this.formatter.getMaxGroup(groups);
    }

    /* helper functions */
    
    private group(r: any, a: any) {
        r[a.ICES] = r[a.ICES] || new ICESReleaseGroup(a.ICES, [], null);
        r[a.ICES].Total += a.Count;
        r[a.ICES].Releases.push(a);
        return r;
    }
}